export default __webpack_public_path__ + "static/media/LTU.e1e4adb2.svg";